export default "__VITE_ASSET__yZuR8GbB__"